import React, { useCallback, useEffect, useRef, useState } from 'react';
import { StyleSheet, View } from "react-native";
import _ from "lodash";
import { colorList } from "utils/colors";
import { useDispatch, useSelector } from "react-redux";
import FetchTimeslotCapacity from "utils/fetch/FetchTimeslotCapacity";
import { addCartTimeslots, removeCartTimeslots } from "services/redux/cart/actions";
import HelperString from 'utils/helper-string'
import selectBookings from 'services/redux/data/selectors/selectBookings'
import { cartConstants } from 'services/redux/cart/constants'
import { dataConstants } from 'services/redux/data/constants'
import PropTypes from 'prop-types'
import ObjectBooking from 'utils/objects/booking'
import HelperAlerts from 'utils/HelperAlerts'
import i18n from 'utils/i18n'
import HelperValidate from 'utils/helper-validate'
import HelperTime from 'utils/helper-time'
import ObjectTimeslot from 'utils/objects/timeslot'
import ObjectEmployee from 'utils/objects/employee'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import DataItem from 'components/atoms/DataItem'
import Translate from 'utils/translate'
import { TESTID } from '_shared/config/testID'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Text from "theme/Text";
import HelperArray from 'utils/helper-array'
import TimeslotIcon from 'components/molecules/TimeslotIcon'
import ThemedItem from 'components/atoms/ThemedItem'
import { createBookingActions } from 'utils/helper-booking'
import LoadingComponent from 'components/atoms/Loading'
import * as Animatable from 'react-native-animatable';
import { constantsActive, constantsGraphql } from 'utils/constants/constants'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import { selectCartEmployees, selectCartTimeslot } from 'services/redux/cart/reducers'
import HelperTimeslot from 'utils/helper-timeslot'
import HelperTimeslotKinds from 'utils/helper-timeslot-kinds'
import useMinute from 'utils/hooks/use-minute'
import HelperTestID from 'utils/HelperTestID'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants, IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import isEqual from 'react-fast-compare'
import { layoutStyles } from 'styles/layout'
import { useNavigation } from '@react-navigation/native'
import { AppRoutes } from 'navigations/app-routes'
import { settingsConstants, settingsOptions } from 'utils/constants/settings-constants'
import { parseHelperTimeslotKindOptions } from 'utils/helper/HelperTimeslotKinds'
import { ThemedValues, ThemedShared } from 'styles/themed'
import HelperDate from 'utils/helper-date'
import FetchCachedOtherEmployeeBookings from 'utils/fetch/cached/FetchCachedOtherEmployeeBookings'
import VStack from 'components/atoms/stack/VStack'
import { bookingStatus } from 'utils/constants/booking-constants'
import HelperSetting from 'utils/helper-setting';
import HStack from 'components/atoms/stack/HStack';
import { useIsSmallDevice } from 'utils/helper-device'
import HelperPlatform from 'utils/helper-platform'
import * as Haptics from 'expo-haptics'

const EMPTY_SELECTION = Object.freeze( [] );

const Timeslot = ({ item = {}, withActions = false, withFavourites = true, title = null, itemProps = CalendarListItemProps.defaults, itemStyle = {}, animationOnMount = false, children, timeslotKind = null, timeslotIconOverWriteProperties = null, testID = null }) => {
	
	const [ cancelableLoading, setCancelableLoading ] = useState( false )
	const navigation = useNavigation();
	const isSmallDevice = useIsSmallDevice();

	const dispatch = useDispatch()
	const overlayText = useRef( [] );
	const overlayInformationText = useRef( [] );
	const itemKey = FetchTimeslotCapacity.keyByBooking( item );

	const employee = _.get( item, 'employee', null );

	const minute = useMinute(); // Keep this hook to render every exact minute
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} ); // Keep for updates

	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	const _cartTimeslots = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} );
	const _cartEmployees = useSelector( selectCartEmployees );
	const _cartTimeslotCurrent = useSelector( state => {
		return selectCartTimeslot(state, itemKey);
	} );
	const _cartTimeslotsLunchOptions = useSelector( state => {
		return _.get(itemProps, 'showLunchSelection', false) ? EMPTY_SELECTION : state.cart[cartConstants.TIMESLOTS_LUNCH_OPTIONS][itemKey];
	} );
	const _cartTimeslotsTransportLicensePlates = useSelector( state => {
		return _.get(itemProps, 'showLicensePlate', false) ? state.cart[cartConstants.TIMESLOTS_TRANSPORT_LICENSE_PLATES][itemKey] : EMPTY_SELECTION;
	} );
	const _lunchOptions = useSelector( state => {
		return state.data[dataConstants.LUNCH_OPTIONS];
	} );

	const itemLunchOptions = _.filter(
		_.map( item.lunch_options, o => {
			const item = _.get( _lunchOptions, o?.lunch_option?.guid, null );
			if( item !== null ) {
				return Translate.field( item, 'title' )
			}
		})
	)
	
	// Get for the employee
	const cartTimeslotsLunchOptionsEmployee = _.get( _cartTimeslotsLunchOptions, employee?.guid, null );
	const cartTimeslotsTransportLicensePlatesEmployee = _.get( _cartTimeslotsTransportLicensePlates, employee?.guid, null );

		// When selectable is active, we replace the icon for the select field
	const selectIsActive = ( _.get( itemProps, 'selectable', null) !== null );
	let checkboxSelected = _.get( itemProps, 'selected', false);

	const identifier = HelperTimeslot.combineKindSubKind( item.timeslot );
	if( timeslotKind === null ) {
		timeslotKind = _timeslotKinds[ identifier ];
	}
	
	const onQrCodePress  = useCallback( ( ) => {
		navigation.navigate( AppRoutes.QRCODE_TIMESLOT, {
			timeslot: item.guid
		} );
	},[]);

	const onCancelable = useCallback( ( cancelable ) => {
		const cancelableEnabled = cancelable?.enabled && _.isFunction( cancelable?.function )

		if( cancelableEnabled ){
			setCancelableLoading( true )
			cancelable?.function( cancelableCallback );
		}
	}, [] );

	const cancelableCallback = () => {
		setCancelableLoading( false )
	}

	const onSelect = async ( { checked, booking } ) => {
		const key = FetchTimeslotCapacity.keyByBooking( booking );

		if( HelperPlatform.isNotWeb() ) {
			Haptics.selectionAsync().catch( () => {
			} );
		}

		if ( checked ) {
			dispatch( addCartTimeslots( { [ key ]: booking } ) );
		} else {
			dispatch( removeCartTimeslots( key ) );
		}
	}

	const addOverlayText = ( value ) => {
		if( overlayText.current.length === 0 ) {
			
			if( _.isArray( value ) ) {
				_.forEach( value, v => {
					overlayText.current.push( v );
				})
				return
			}
			
			overlayText.current.push( value );
		}
	}

	const addOverlayInformationText = ( value ) => {
		if( overlayInformationText.current.length === 0 ) {
			if( !overlayInformationText.current.includes( value ) ) {
				overlayInformationText.current.push( value );
			}
		}
	}

	const onPressSelect = async ( { checked, booking, warning = false, warningOverlaps = [] } ) => {
		if( warning !== false && _.has( warning, 'title' ) ) {
			HelperAlerts.alert(
				warning.title,
				_.get( warning, 'body', '' ),
				[
					{
						text: i18n.t('page.create.date.warning.cart.button_cancel'),
					},
					{
						text: i18n.t('page.create.date.warning.cart.button_ok'),
						onPress: () => {
							// Deselect?
							_.forEach( warningOverlaps, warningOverlap => {
								if( HelperTime.checkOverlap( HelperTime.createSegments( booking, [ warningOverlap ] ) ) ) {
									onSelect({ checked: false, booking: warningOverlap })
								}
							})

							// And select the new
							onSelect( { checked, booking } )
						}
					}
				]
			);
			return;
		}

		onSelect( { checked: checked, booking: booking } );
	}

	const isSelectedDifferentFloor = ( item ) => {
		return isSelectedDifferent( item, 'floor' );
	}

	const isSelectedDifferentBuilding = ( item ) => {
		return isSelectedDifferent( item, 'building' );
	}

	const isSelectedDifferent = ( item, key ) => {
		let isSelected = false;

		_.forEach( _cartTimeslots, o => {
			const oKey = _.get( o, key, null )
			const itemKey = _.get( item, key, null )

			// Check if the objects are valid
			if( HelperValidate.isValid( oKey ) && HelperValidate.isValid( itemKey ) ) {

				// Compare the guids
				if( oKey.guid !== itemKey.guid ) {

					// Compare the dates
					if( o.booking_date === item.booking_date && o.timeslot?.kind === item.timeslot?.kind && o.timeslot?.sub_kind === item.timeslot?.sub_kind ) {
						const doesOverlap = HelperTime.checkOverlap(
							HelperTime.createSegments(
								o,
								item
							)
						);

						// If it overlaps, we remove the old one
						if( doesOverlap ) {
							isSelected = o;
						}
					}
				}
			}
		})

		return {
			selected: isSelected !== false,
			item: isSelected
		};
	}

	// Add one prop
	itemProps['selectableDisabled'] = _.get( item, 'disabled', itemProps?.selectableDisabled )

	const _bookings = useSelector( selectBookings );

	const timeslot = ObjectBooking.getTimeSlot( item );

	useEffect( () => {
		overlayText.current = [];
	}, [ _cartTimeslotCurrent ])

	// Employees which already selected
	const {
		timeslotCapacity,

		isTimeslotBooked,
		isInvited,
		isInviter,
		isInvitation,
		isTimeslotAvailable,

		placesAvailable,
		employeeDidAlreadyBook,
		employeeBookingStatusInvited,

		bookForMyself,
		bookForMultiple,

		personAmount,
		enoughPlacesAvailable
	} = ObjectTimeslot.collect( item );
	
	const bookingsAndCartTimeslotsCombined = {
		...ObjectBooking.filterAccepted( _bookings ),
		..._cartTimeslots
	}
	
	// Get the amount of credits
	const creditAmount = timeslotKind?.credit_amount ?? 0;
	
	const showCapacityInTimeslot = _.get( timeslotKind, 'show_capacity_in_timeslot', settingsOptions.YES ) === settingsOptions.YES;
	
	// Parse the options
	const { canBookFrom, canBookUntil, canOverlapWithBooking, canOnlySelectOnePerDay } = parseHelperTimeslotKindOptions( timeslotKind )
	
	// Get the options from the timeslot kind
	const { can: timeslotCanBookByFrom, date: timeslotCanBookByFromDate, extract: timeslotCanBookByFromExtract } = HelperTimeslotKinds.canBookByFrom( item, canBookFrom, timeslotCapacity );
	const { can: timeslotCanBookByUntil, date: timeslotCanBookByUntilDate, extract: timeslotCanBookByUntilExtract } = HelperTimeslotKinds.canBookByUntil( item, canBookUntil, timeslotCapacity );
	
	// Check if past deadline
	// If past deadline AND timeslot selected -> deselect
	if( !_.isEmpty( _cartTimeslotCurrent ) ) {
		if( !timeslotCanBookByUntil || !timeslotCanBookByFrom ) {
			onSelect( { checked: false, booking: _cartTimeslotCurrent } );
		}
	}

	// Filter already created bookings for today by kind
	const bookedTodayByKindSubKind = {};
	_.forEach( ObjectBooking.filterAccepted( _bookings ), o => {
		if( o.booking_date === item.booking_date && FetchTimeslotCapacity.keyByBooking( o ) !== itemKey ) {
			const kindSubKind = HelperTimeslot.combineKindSubKind( o.timeslot )
			if( !_.has( bookedTodayByKindSubKind, kindSubKind ) ) {
				bookedTodayByKindSubKind[ kindSubKind ] = [];
			}
			bookedTodayByKindSubKind[ kindSubKind ].push( o )
		}
	});

	const bookedToday = _.get( bookedTodayByKindSubKind, HelperTimeslot.combineKindSubKind( item.timeslot ), [] );

	const selectedTodayByKindSubKind = {};
	const selectedTodayByKind = {};
	_.forEach( bookingsAndCartTimeslotsCombined, o => {
		if( o.booking_date === item.booking_date && FetchTimeslotCapacity.keyByBooking( o ) !== itemKey ) {
			//
			if( !_.has( selectedTodayByKind, o.timeslot?.kind ) ) {
				selectedTodayByKind[ o.timeslot?.kind ] = [];
			}
			selectedTodayByKind[ o.timeslot?.kind ].push( o )

			//
			const kindSubKind = HelperTimeslot.combineKindSubKind( o.timeslot )
			if( !_.has( selectedTodayByKindSubKind, kindSubKind ) ) {
				selectedTodayByKindSubKind[ kindSubKind ] = [];
			}
			selectedTodayByKindSubKind[ kindSubKind ].push( o )
		}
	});

	// Check if already selected
	const selectedToday = _.get( selectedTodayByKindSubKind, HelperTimeslot.combineKindSubKind( item.timeslot ), [] );

	// Check for overlaps, but only when booking for myself
	let selectedDoesOverlapBooking = false;
	let selectedDoesOverlapKindSubKind = false;
	let bookedDoesOverlapKindSubKind = false;
	let bookedTimeSlotGroupToday = false;
	
	if( bookForMyself ) {
		// Check already booked
		bookedDoesOverlapKindSubKind = HelperTime.checkOverlap( HelperTime.createSegments( item, bookedToday ) );

		// By kind and sub kind
		selectedDoesOverlapKindSubKind = HelperTime.checkOverlap( HelperTime.createSegments( item, selectedToday ) );
		
		if( selectedDoesOverlapKindSubKind ) {
			if( canOverlapWithBooking === constantsGraphql.YES ) {
				selectedDoesOverlapKindSubKind = false;
			}
			
			// Check if this user may overlap this kind
			if( ObjectEmployee.mayOverlap( item.timeslot?.kind ) ) {
				selectedDoesOverlapKindSubKind = false;
			}
		}

		// Booking kind specific
		selectedDoesOverlapBooking = HelperTime.checkOverlap( HelperTime.createSegments( item, _.get( selectedTodayByKind, timeslotKindConstants.BOOKING, [] ) ) );
		
		if( selectedDoesOverlapBooking ) {
			if( canOverlapWithBooking === constantsGraphql.YES ) {
				selectedDoesOverlapBooking = false;
			}
			
			// Check if this user may overlap this kind
			if( ObjectEmployee.mayOverlap( item.timeslot?.kind ) ) {
				selectedDoesOverlapBooking = false;
			}
		}

		if( _.get( itemProps, [ 'timeslotGroup', 'can_only_book_single_timeslot_per_day' ], constantsActive.NO ) === constantsActive.YES ){
			if( !_.isEmpty( _.get( selectedTodayByKind, _.get( item, 'kind', timeslotKindConstants.BOOKING ), [] ) ) ) {
				bookedTimeSlotGroupToday = true;
			}
		}
	}

	if( selectIsActive ) {
		checkboxSelected = _.get( _cartTimeslots, itemKey, undefined ) !== undefined;
	}

	// CHECKS
	let isSelectable = false;
	if( selectIsActive || itemProps.previewing ) {
		const isMeetingRoom = item.timeslot?.kind === timeslotKindConstants.MEETING_ROOM;

		// Check if we can select the item (only set to true if we're not previewing
		isSelectable = !itemProps.previewing;
		
		// Book for myself
		switch( true ) {
			case timeslotCapacity.block_comment !== null && HelperString.isEmptyString( timeslotCapacity.block_comment ) === false:
				addOverlayText( timeslotCapacity.block_comment === 'block' ? i18n.t( 'page.create.date.disabled_block' ) : timeslotCapacity.block_comment );
				break;
			
			// If it is an invitation (and you are not viewing it) and you are invited BUT you are not the inviter -> you can do nothing with it
			case bookForMyself && isInvitation && !itemProps.isViewingInvitation && isInvited && !isInviter && !employeeBookingStatusInvited:
				addOverlayText( i18n.t( 'page.create.date.disabled_not_inviter' ) );
				break;

			// When not an invitation and I did already book NOT selectable
			case bookForMyself && !bookForMultiple && !isInvitation && employeeDidAlreadyBook:
				addOverlayText( i18n.t( 'page.create.date.disabled_already_booked_single' ) );
				break;

			// When booking for yourself and not for others, it is an in
			case bookForMyself && !bookForMultiple && isInvitation && employeeDidAlreadyBook && !employeeBookingStatusInvited:
				addOverlayText( i18n.t( 'page.create.date.disabled_already_booked_single' ) );
				break;

			case bookForMyself && bookedTimeSlotGroupToday:
				addOverlayText( i18n.t( 'page.create.date.disabled_already_booked_single_timeslot_group' ) );
				break;

			// When booking for yourself and NOT for others and may only select one per day and already selected
			case bookForMyself && !bookForMultiple && canOnlySelectOnePerDay === constantsActive.YES && !_.isEmpty( selectedToday ):
				addOverlayText([
					i18n.t( 'page.create.date.disabled_already_booked_single_timeslot_kind', {
						kind: _.toLower( i18n.t(`constants.timeslots.${ item.kind }`) ),
					} ),
					i18n.t( 'page.create.date.disabled_already_booked_single_timeslot_kind_current', {
						current:  FetchCachedOtherEmployeeBookings.createLocationName( _.first( selectedToday ) )
					} )
				]);
				break;

			// INFORMATION LAYER
			case bookForMyself && bookForMultiple && isInvitation && isInviter && employeeDidAlreadyBook:
				addOverlayInformationText( i18n.t( 'page.create.date.information_invitation_exists' ) );
				break;
		}

		// If the timeslot kind may NOT overlap with a booking
		// AND the item DOES overlap with the booking
		// -- and the default yada yada --
		// THEN disable it with overlapping
		if( isTimeslotAvailable && !itemProps.selectableDisabled && ( bookForMultiple || !employeeDidAlreadyBook ) ) {
			if( canOverlapWithBooking !== constantsGraphql.YES ) {
				if( selectedDoesOverlapBooking ) {
					addOverlayText( i18n.t( 'page.create.date.disabled_overlap' ) );
				}
	
				// Check if it is already overlapping?
				if( bookedDoesOverlapKindSubKind ) {
					addOverlayText( i18n.t( 'page.create.date.disabled_overlap' ) );
				}
			}
		}

		// When meeting room and the timeslot is NOT available and I am not in it -> show already booked
		// Meeting room has a limit of 1 invitation OR booking
		if( isMeetingRoom ) {
			switch( true ) {
				case itemProps.previewing && employeeDidAlreadyBook:
					addOverlayText( i18n.t( 'page.create.date.disabled_already_booked_single' ) );
					break;

				case !itemProps.isViewingInvitation && isInvitation && !employeeDidAlreadyBook && !isTimeslotAvailable:
					addOverlayText( i18n.t( 'page.create.date.disabled_already_booked' ) );
					break;

				case !itemProps.isViewingInvitation && !isInvitation && !isInvited && !employeeDidAlreadyBook && isTimeslotBooked:
					addOverlayText( i18n.t( 'page.create.date.disabled_already_booked' ) );
					break;
			}
		}
		
		// Check the book from
		if( !timeslotCanBookByFrom ) {
			const { amount, unit, timeFrom } = timeslotCanBookByFromExtract

			//disabled_before_from_time_today
			//addOverlayText( i18n.t( !HelperValidate.isValid( timeFrom ) ? 'page.create.date.disabled_before_from' : 'page.create.date.disabled_before_from_time', {
			addOverlayText( i18n.t( 'page.create.date.disabled_before_from' , {
				amount,
				unit: _.toLower( i18n.t(`unit.${unit}`, { count: amount } ) ),
				time: !HelperValidate.isValid( timeFrom ) ? null : HelperDate.time( timeFrom ).format( 'HH:mm' )
			} ) );
		}
		
		// Check the book until
		// Check if the deadline is not yet passed
		if( !timeslotCanBookByUntil ) {
			const { amount, unit, timeFrom } = timeslotCanBookByUntilExtract

			let label = !HelperValidate.isValid( timeFrom ) ? 'page.create.date.disabled_deadline_passed' : 'page.create.date.disabled_deadline_passed_time'
			if( amount === 0 ) {
				label = !HelperValidate.isValid( timeFrom ) ? 'page.create.date.disabled_deadline_passed' : 'page.create.date.disabled_deadline_passed_time_today'
			}
			
			addOverlayText( i18n.t( label, {
				amount,
				unit: _.toLower( i18n.t(`unit.${unit}`, { count: amount } ) ),
				time: !HelperValidate.isValid( timeFrom ) ? null : HelperDate.time( timeFrom ).format( 'HH:mm' )
			} ) );
		}

		// Not enough places available? Show the text
		switch( true ) {
			case !itemProps.isViewingInvitation && !isInvitation && !isInvited && !enoughPlacesAvailable:
			case !itemProps.isViewingInvitation && isInvitation && (!bookForMyself && bookForMultiple) && !enoughPlacesAvailable:
				addOverlayText( i18n.t( 'page.create.date.disabled_not_enough_available', {
					count: personAmount
				} ) );
				break;
		}

		// Last check! Only add when there are no overlays YET
		if( _.size( overlayText.current ) === 0 ) {
			// Check if we can select the item
			if( !enoughPlacesAvailable || !isTimeslotAvailable || itemProps.selectableDisabled ) {
				addOverlayText( i18n.t( 'page.create.date.disabled_not_available' ) );
			}
		}
	}

	// When there is a text over the item -> then it is not selectable...
	if( _.size( overlayText.current ) > 0 ) {
		isSelectable = false;
	}

	//
	const headerIconStyle = [ DataItemStyles.headerIcon ];

	// Create the title
	const dataItems = [];
	const overLayItems = [];
	// Check if we need to add the 'coworker' label
	if( !_.isEmpty( _cartTimeslots ) && _.size( _cartEmployees ) > 1 ) {
		if( _.get( item, 'employee', null ) !== null ) {
			const itemEmployee = _.get( item, ['employee'], '' );

			let itemContent = _.get( itemEmployee, ['name'], '' )
			if( _employee.guid === itemEmployee.guid ) {
				itemContent = i18n.t('basic.yourself')
			}

			dataItems.push(
				<DataItem
					key={ HelperString.hash('employee', itemKey ) }
					identifier={ 'employee' }
					icon={ <Icon icon={ IconSystemConstants.PERSON } style={ headerIconStyle } /> }
					content={ itemContent }>

					{ i18n.t( 'constants.coworker' ) }
				</DataItem>
			);
		}
	}

	if( overlayText.current.length > 0 ) {
		overLayItems.push(
			<View
				key={ HelperString.hash( 'overlayTextContainer', itemKey ) }
				style={ styles.overlayContainer }>

				<View
					style={ styles.overlayContentContainer }>

					<DataItem
						key={ HelperString.hash( 'overlayText', itemKey ) }
						identifier={ "overlayText" }
						textStyle={ styles.dataItemMarginLeft0 }
						content={(
							<HStack
								itemStyle={ layoutStyles.flexNone }
								style={styles.hStackJustifyContentFlexStartAlignItemsCenter}>

								<Icon
									icon={ IconSystemConstants.WARNING }
									style={ styles.dotIcon }
								/>
								
								<VStack
									style={[styles.vStackAlignItemsCenterJustifyContentCenter]}>

									{ _.map( overlayText.current, ( value, index ) => {
										return (
											<Text
												key={ HelperString.hash( `overlayText-text-value-${ index }`, itemKey ) }
												style={[
													styles.overlayText,
													index === 0 ? {} : styles.overlayTextSmall
												]}>

												{ value }
											</Text>
										)
									})}
								</VStack>
							</HStack>
						)}
						style={ styles.dataItemMarginBottom0 }
					/>
				</View>
			</View>
		);
	}

	if( HelperSetting.isYes( settingsConstants.CREDITS_ENABLED ) && creditAmount > 0 ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('credit', itemKey ) }
				identifier={ 'credit' }
				icon={ <Icon icon={ IconSystemConstants.PAY } style={ headerIconStyle } /> }
				content={ creditAmount }>

				{ i18n.t( 'constants.credit' ) }
			</DataItem>
		);
	}

	switch( true ) {
		case itemProps.showCapacity && timeslotCapacity.capacity !== null && timeslotCapacity.capacity > 0:
			if( showCapacityInTimeslot ){ // Keep this as an 'if', it prevents other fields like location to be shown!
				let dataIcon = null;
				let dataTitle = null;

				if( timeslotKind !== undefined ){
					dataIcon = <Icon icon={ timeslotKind.icon } {...{ style: headerIconStyle }} />;
					dataTitle = Translate.field( timeslotKind, 'count', 'name', null, 'title' );
				}

				if( _.isEmpty( dataIcon ) ) {
					switch( item.timeslot?.kind ) {
						case timeslotKindConstants.LUNCH:
							dataIcon = <Icon icon={ IconTimeslotConstants.LUNCH }  style={ headerIconStyle } />;
							break;

						case timeslotKindConstants.MEETING_ROOM:
							dataIcon = <Icon icon={ IconTimeslotConstants.MEETING_ROOM }  style={ headerIconStyle } />;
							break;

						case timeslotKindConstants.TRANSPORT:
							dataIcon = <Icon icon={ IconTimeslotConstants.CAR }  style={ headerIconStyle } />;
							break;

						default:
							dataIcon = <Icon icon={ IconTimeslotConstants.WORKPLACE } style={ headerIconStyle } />;
							break;
					}
				}

				if( HelperString.isEmptyString( dataTitle ) ){
					switch( item.timeslot?.kind ) {
						case timeslotKindConstants.LUNCH:
							dataTitle = i18n.t( 'constants.lunches_count' );
							break;

						case timeslotKindConstants.MEETING_ROOM:
							dataTitle = i18n.t( 'constants.meetingroom_count' );
							break;

						case timeslotKindConstants.TRANSPORT:
							dataTitle = i18n.t( 'constants.transport_count' );
							break;

						default:
							dataTitle = i18n.t( 'constants.workplaces_count' );
							break;
					}
				}

				dataItems.push(
					<DataItem
						key={ HelperString.hash('workplaces_count', itemKey ) }
						identifier={ 'workplaces_count' }
						icon={ dataIcon }
						content={ placesAvailable }>

						{ dataTitle }
					</DataItem>
				);
			}

			break;

		case itemProps.showCapacity && timeslotCapacity.capacity !== null && timeslotCapacity.capacity === -1:
			// Nothing
			break;

		default:
			const locationText = []
			_.forEach( ['building', 'floor', 'room'], name => {
				const itemName = Translate.field( item[ name ], 'title' );

				if( !HelperString.isEmptyString( itemName ) ) {
					locationText.push( itemName );
				}
			});
			
			if( !_.isEmpty( locationText ) ){
				let content = '';
				_.forEach( locationText, ( value, index ) => {
					if( value !== null && !HelperString.isEmptyString( value ) ){
						content += value;
						if( index < content.length > 0 ){
							content += ', ';
						}
					}
				});
				
				if( !HelperString.isEmptyString( content ) ) {
					dataItems.push(
						<DataItem
							key={ HelperString.hash('location', itemKey ) }
							identifier={ 'location' }
							icon={ <Icon icon={ IconSystemConstants.BUILDING }  style={ headerIconStyle } />  }
							content={ content }>
							
							{ i18n.t( 'constants.location' ) }
						</DataItem>
					);
				}
			}
	}
	
	if( withFavourites ) {
		const favourites = _.filter( ( timeslotCapacity?.employee_favourites_names ?? '' ).split('|||'), o => {
			return !HelperString.isEmptyString(o);
		} );
		if ( _.size( favourites ) > 0 ) {
			// Sort the favourites alphabetically
			const sortedFavourites = favourites.sort();
			
			dataItems.push(
				<DataItem
					key={ HelperString.hash('coworkers', HelperString.random() ) }
					icon={ <Icon icon={ IconSystemConstants.PERSONS } style={ [ DataItemStyles.headerIcon ] } checked={true} /> }
					identifier={ 'coworkers' }
					content={(
						<Text
							key={ HelperString.hash('coworker-favourites') }
							style={ DataItemStyles.text }>
							
							{ HelperArray.naturalJoin( sortedFavourites ) }
						</Text>
					)}>
					
					{ i18n.t( 'constants.coworkers_booked' ) }
				</DataItem>
			);
		}
	}
	
	// Check if it is still checking
	if( item.status === bookingStatus.MANUAL_VALIDATION ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('validation', itemKey ) }
				identifier={ 'validation' }
				icon={ <Icon icon={ IconSystemConstants.PERSON_CHECK }  style={ headerIconStyle } />  }
				content={ null }>
				
				{ i18n.t( 'page.booking.status_manual_validation' ) }
			</DataItem>
		);
	}

	if( _.isEmpty( overlayText.current ) && !_.isEmpty( overlayInformationText.current ) ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('overlayInformationText', itemKey ) }
				identifier={ "overlayInformationText" }
				icon={ <Icon icon={ IconSystemConstants.INFO } style={ [ DataItemStyles.headerIcon ] } /> }
				content={ HelperArray.naturalJoin( overlayInformationText.current ) }
				titleStyle={styles.dataItemColorPrimary}>

				{ i18n.t( 'constants.information' ) }
			</DataItem>
		)
	}
	
	const description = Translate.field( _.get( item, 'timeslot', {} ), 'description', null )
	
	// When custom add the timeslot kind title
	if( HelperTimeslotKinds.isCustom( timeslotKind ) ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('timeslot-kind-title', itemKey ) }
				identifier={ 'information' }
				icon={ <Icon icon={ IconSystemConstants.INFO } style={  headerIconStyle } /> }
				content={ description }>

				{ Translate.field( timeslotKind, 'title' ) }
			</DataItem>
		);
	}

	switch( true ) {
		case description !== null:
			dataItems.push(
				<DataItem
					key={ HelperString.hash('information-description', itemKey ) }
					identifier={ 'information' }
					icon={ <Icon icon={ IconSystemConstants.INFO } style={  headerIconStyle } /> }
					content={ description }>

					{ i18n.t( 'constants.information' ) }
				</DataItem>
			);
			break;

		case _.get( item, 'label', null ) !== null:
			dataItems.push(
				<DataItem
					key={ HelperString.hash('information-label', itemKey ) }
					identifier={ 'information' }
					icon={ <Icon icon={ IconSystemConstants.INFO } style={  headerIconStyle } /> }
					content={ _.get( item, 'label') }>

					{ i18n.t( 'constants.information' ) }
				</DataItem>
			);
			break;
	}

	/*  _cartTimeslotsTransportLicensePlates, _cartTimeslotsLunchOptions */
	if( itemProps.showLunchSelection ) {
		if( cartTimeslotsLunchOptionsEmployee !== null ) {
			const value = _.get( _lunchOptions, cartTimeslotsLunchOptionsEmployee, {} );

			if( !_.isEmpty( value ) ) {
				dataItems.push(
					<DataItem
						key={ HelperString.hash('lunch', itemKey ) }
						identifier={ 'lunch' }
						icon={ <Icon icon={ IconTimeslotConstants.LUNCH } style={ headerIconStyle } />  }
						content={ Translate.field( value, 'title' ) }>

						{ i18n.t( 'constants.lunch_option' ) }
					</DataItem>
				);
			}
		}
	}
	
	if( itemProps.showLunchOptions ) {
		if( _.size( itemLunchOptions ) > 0 ) {
			dataItems.push(
				<DataItem
					key={ HelperString.hash('lunch-options', itemKey ) }
					identifier={ 'lunch-options' }
					icon={ <Icon icon={ IconTimeslotConstants.LUNCH } style={ headerIconStyle } /> }
					content={ HelperArray.naturalJoin( itemLunchOptions ) }>

					{ i18n.t( 'constants.lunch_option' ) }
				</DataItem>
			);
		}
	}

	if( itemProps.showLicensePlate ) {
		if( cartTimeslotsTransportLicensePlatesEmployee !== null ) {
			dataItems.push(
				<DataItem
					key={ HelperString.hash('license-plate', itemKey ) }
					identifier={ 'license-plate' }
					icon={ <Icon icon={ IconTimeslotConstants.CAR } style={ headerIconStyle } /> }
					content={ cartTimeslotsTransportLicensePlatesEmployee }>

					{ i18n.t( 'constants.license_plate' ) }
				</DataItem>
			);
		}
	}

	// Selected check
	//const selectedDifferentBuilding = isSelectedDifferentBuilding( item );
	//const selectedDifferentFloor = isSelectedDifferentFloor( item );

	if( testID === null ){
		testID = HelperTestID.generate( TESTID.HOME.BOOK.TIMESLOTS.TIMESLOT, [item.timeslot?.kind, item.timeslot?.sub_kind ] );
	}

	if( title === null && _.get( timeslotKind, 'show_time', constantsActive.YES ) === constantsActive.YES ) {
		title = `${_.get( timeslot, 0, null )} - ${ _.get( timeslot, 1, null ) } `;
	}

	const iconComponent = (
		<TimeslotIcon
			timeslot={ _.get( item, [ 'timeslot' ], {} ) }
			overWriteProperties={ timeslotIconOverWriteProperties}
		/>
	)

	let actionItems = [];
	if( isSelectable ) {
		actionItems.push(
			<Icon
				key={ HelperString.hash('selectable', itemKey ) }
				icon={ IconSystemConstants.CHECKBOX }
				checked={ checkboxSelected }
				size={ 20 }
				color={ checkboxSelected ? colorList.ORANGE.primary : colorList.GREY.dark  }
			/>
		);
	}

	let doShowQrCode = false;
	if( _.get( itemProps, 'showQrCode', false ) && _.get( timeslotKind, 'can_scan_presence_qr_code', settingsOptions.NO ) === settingsOptions.YES ) {
		const qrcodeFrom = _.get( timeslotKind, 'can_scan_presence_qr_code_from', 'minutes:30:-' );
		const qrcodeTill = _.get( timeslotKind, 'can_scan_presence_qr_code_until', 'minutes:30:+' );

		if( qrcodeFrom !== 'always' ) {
			const timeslotStart = _.get( item, [ 'timeslot', 'timeslot_start' ] );

			const now = HelperDate.date();
			const dateFrom = HelperTimeslotKinds.getDateFromExtract( HelperDate.date( `m:${ item.booking_date } ${ timeslotStart }` ), HelperTimeslotKinds.extractUntilTime( qrcodeFrom ) );
			const dateTill = HelperTimeslotKinds.getDateFromExtract( HelperDate.date( `m:${ item.booking_date } ${ timeslotStart }` ), HelperTimeslotKinds.extractUntilTime( qrcodeTill ) );

			if ( now.isAfter( dateFrom ) && ( qrcodeTill === 'always' || now.isBefore( dateTill )) ) {
				doShowQrCode = true;
			}
		} else {
			doShowQrCode = true;
		}

		if ( doShowQrCode ) {
			actionItems.push(
				<View
					key={ HelperString.hash('qr-code', itemKey )}>

					<Icon
						icon={ IconSystemConstants.QRCODE }
						size={ 20 }
						color={ colorList.BLACK.dark  }
					/>
				</View>
			)
		}
	}

	if( withActions ) {
		const { cancelable } = createBookingActions( item, withActions );

		// For the cancel button
		if( cancelable !== null ) {
			if( cancelableLoading === false ) {
				actionItems.push(
					<ThemedPressable
						key={ HelperString.hash('calendar-list-item-cancelable-button', itemKey ) }
						testID={ HelperTestID.generate( testID, TESTID.HOME.BOOK.TIMESLOTS.SUFFIX_DELETE_BUTTON ) }
						onPress={ onCancelable.bind( this, cancelable ) }>

						<Icon
							icon={ IconSystemConstants.TRASH }
							size={ 20 }
							color={ cancelable?.enabled ? colorList.RED.primary : colorList.GREY.dark  }
						/>
					</ThemedPressable>
				)
			} else {
				actionItems.push(
					<LoadingComponent
						key={ HelperString.hash('calendar-list-item-loading', itemKey ) }
						containerStyle={ styles.loadingComponentPadding0 }
						size={ 'xs' }
					/>
				)
			}
		}
	}

	//
	let content = (
		<View
			key={ HelperString.hash('view-no-action', FetchTimeslotCapacity.keyByBooking( item ) ) }
			style={ [
				styles.container,
				isSmallDevice && checkboxSelected ? styles.containerSelected : null,
				itemStyle,
			] }>

			<ThemedItem
				key={ HelperString.hash(  'calendar-item', itemKey ) }
				identifier={ HelperString.hash(  'calendar-item-id', itemKey ) }
				accessoryLeft={ iconComponent }
				accessoryLeftSize={ 40 }
				title={ title }
				items={ dataItems }
				actionItem={ actionItems }
				testID={ testID }>

				{/* Child component */}
				<View style={ styles.childrenContainer }>
					{ children }
				</View>

				{/* Overlay text */}
				{ overLayItems }
			</ThemedItem>
		</View>
	);

	if( animationOnMount ) {
		if( animationOnMount === true ) {
			animationOnMount = 'bounceIn';
		}

		content = (
			<Animatable.View
				style={ layoutStyles.flexOne }
				animation={ animationOnMount }>

				{ content }
			</Animatable.View>
		);
	}

	if( _.size( overlayText.current ) > 0 ) {
		content = (
			<View style={ styles.overlay }>
				<View style={ styles.overlayChild }>
					{ content }
				</View>
			</View>
		)
	}

	if( doShowQrCode ){
		return (
			<ThemedPressable
				key={ HelperString.hash('calendar-list-item-qrcode-button', itemKey ) }
				onPress={ onQrCodePress.bind( this ) }
				testID={ HelperTestID.generate( testID, TESTID.HOME.BOOK.TIMESLOTS.SUFFIX_QRCODE_BUTTON ) }>

				{ content }
			</ThemedPressable>
		)
	}

	// Make the whole view clickable
	// Create ALERT when overlap
	if( selectIsActive && isSelectable ) {
		let onSelectObject = {
			checked: !checkboxSelected,
			booking: item
		}

		// Create the warning
		//if( selectedDoesOverlapKindSubKind || selectedDifferentBuilding.selected || selectedDifferentFloor.selected ) {
		if( selectedDoesOverlapKindSubKind ) {
			onSelectObject = {
				...onSelectObject,
				warning: {
					title: i18n.t('page.create.date.warning.cart.title'),
					body: i18n.t('page.create.date.warning.cart.body'),
				},
				warningOverlaps: selectedToday
			}
		}

		return (
			<ThemedPressable
				style={ layoutStyles.flexOne }
				accessibilityRole="checkbox"
				accessibilityState={{ checked: checkboxSelected, disabled: !isSelectable }}
				onPress={ onPressSelect.bind( this, onSelectObject ) }>

				{ content }
			</ThemedPressable>
		);
	}

	return content;
}

export const CalendarListItemProps = {
	types: {
		contentProps: PropTypes.object,

		showCapacity: PropTypes.bool,
		showLunchSelection: PropTypes.bool,
		showLicensePlate: PropTypes.bool,

		selectable: PropTypes.string,
		selectableDisabled: PropTypes.bool,

		selected: PropTypes.bool,
	},
	defaults: {
		contentProps: {},

		isViewingInvitation: false,
		showCapacity: false,
		showLunchSelection: false,
		showLicensePlate: false,

		selectable: null,
		selectableDisabled: false,

		selected: false,
	}
};

const styles = StyleSheet.create( {
	dataItemMarginLeft0: {
		marginLeft: 0,
	},
	hStackJustifyContentFlexStartAlignItemsCenter: {
		justifyContent: 'flex-start',
		alignItems: 'center',
		flex: 1,
	},
	vStackAlignItemsCenterJustifyContentCenter: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	dataItemMarginBottom0: {
		marginBottom: 0,
	},
	dataItemColorPrimary: {
		color: colorList.RED.primary,
	},
	loadingComponentPadding0: {
		padding: 0,
	},
	container: {
		paddingHorizontal: 8,
		flexDirection: 'row',
		height: 'auto',
	},
	containerSelected: {
		paddingLeft: 4,
		borderLeftWidth: 4,
		borderLeftColor: colorList.PRIMARY.dark,
		backgroundColor: colorList.PRIMARY.lighter,
	},

	childrenContainer: {
		flex: 1,
		justifyContent: 'flex-end',
	},
	employeeContainer: {
		alignItems: 'flex-start'
	},

	overlay: {
		flex: 1,
	},
	overlayChild: {
		opacity: 1
	},
	overlayContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba( 255, 255, 255, 0.5 )'
	},
	overlayContentContainer: {
		padding: ThemedShared.paddingSmall.padding,
		backgroundColor: colorList.WHITE.primary,
		borderWidth: 1,
		borderColor: colorList.GREY.dark,
		borderRadius: ThemedValues.borderRadius
	},
	overlayText: {
		fontWeight: '700',
		color: colorList.RED.primary,
		textAlign: 'center',
		fontSize: 12,
		maxWidth: '100%',
		// backgroundColor: 'blue'
	},
	overlayTextSmall: {
		fontSize: 10,
	},
	informationRow: {
		flexDirection: 'row',
		paddingVertical: 2
	},
	informationRowItem: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'flex-start',
	},

	overlayInformationText: {
		fontWeight: '700',
		fontSize: 12
	},

	dotIcon: {
		...layoutStyles.flexUnset,
		fontSize: 14,
		color: colorList.BADGE.primary,
	},
	dotInformationIcon: {
		fontSize: 14,
		color: colorList.ORANGE.primary,
	}
});

//Timeslot.whyDidYouRender = true;

export default React.memo( Timeslot, isEqual );
